<ion-content class="theme-{{userService.theme}}">
  <ion-header>
    <app-header [backRoute]="['/team']"></app-header>
  </ion-header>
  <div class="page-width-and-shadow">
    <div class="details-wrap">
      <div class="top-box">
        <div class="button" [@enter] [@leave]>
          <img *ngIf="data !== null && prevDelegateId > 0" src="assets/img/left-grey.svg" (click)="prevTeamMember()"
               alt="#">
        </div>
        <div class="text" [@enter] [@leave]>
          <img *ngIf="data !== null && !!data.delegate.avatar" class="avatar" [src]="data.delegate.avatar.url">
          <app-inline-svg *ngIf="data === null || !data.delegate.avatar" [file]="'assets/img/user-blue.svg'"></app-inline-svg>
          <span *ngIf="data !== null">{{data.delegate.full_name}}</span>
          <span *ngIf="data === null"><ion-skeleton-text animated></ion-skeleton-text></span>
        </div>
        <div class="button" [@enter] [@leave]>
          <img *ngIf="data !== null && nextDelegateId > 0" src="assets/img/right-grey.svg" (click)="nextTeamMember()"
               alt="#">
        </div>
      </div>
    </div>

    <div class="calls-history-wrap" *ngIf="data !== null">
      <iframe *ngIf="!!data.url" [src]="data.url | safeUrl" allow="microphone *; clipboard-read *; clipboard-write *"></iframe>
    </div>

    <div class="list-wrap" *ngIf="data === null">
      <div class="line-text content-wrap-inner compact">
        <ion-skeleton-text animated style="width: 80%; height: 1.5rem"></ion-skeleton-text>
      </div>
      <div class="list content-wrap-inner compact" style="border-top: none">
        <app-skeleton-tasks></app-skeleton-tasks>
      </div>
    </div>
  </div>
</ion-content>



